import * as Sentry from '@sentry/browser'
import {
  osVersion,
  osName,
  fullBrowserVersion,
  getUA,
  engineVersion,
  engineName,
  mobileModel,
  browserVersion,
} from 'react-device-detect'

import { sentryRavenLink } from 'app/config'
import { loadScript } from 'helpers/loadScriptAsync'
import { store } from '../store'
import { lastAction } from 'store/entities/offline/selectors'

/**
 * Sentry Raven
 * @see https://docs.sentry.io/clients/javascript/integrations/react/
 * @return {Promise<any>}
 */
export function ravenInit() {
  return new Promise((resolve, reject) => {
    try {
      if (sentryRavenLink) {
        loadScript('https://cdn.ravenjs.com/3.26.4/raven.min.js')
          .catch(reject)
          .then(() => {
            const RavenInit = Sentry.init({
              dsn: sentryRavenLink,
              environment: process.env.SERVER || 'dev',
              beforeSend: (exception, dataError) => {
                const identity = store.getState().get('persist')['identity']
                exception.user.email = identity.get('email')
                exception.extra.state = store.getState().toJS()
                // TODO: @serginyo90 need update recent below
                // As application state can be very large and easily exceed the 200kB maximum that Sentry has on individual event payloads.
                // We catch the error "413 Request Entity Too Large" if we save feed
                exception.extra.state.feed.recent = null
                exception.extra.lastAction = lastAction(store.getState())
                exception.extra.dataError = dataError
                return exception
              },
            })
            resolve(RavenInit)
          })
          .then(() => {
            Sentry.configureScope(scope => {
              scope.setUser({ email: 'default@email.com' })
              scope.setExtra('osVersion', osVersion)
              scope.setExtra('osName', osName)
              scope.setExtra('fullBrowserVersion', fullBrowserVersion)
              scope.setExtra('getUA', getUA)
              scope.setExtra('engineVersion', engineVersion)
              scope.setExtra('engineName', engineName)
              scope.setExtra('mobileModel', mobileModel)
              scope.setExtra('browserVersion', browserVersion)
            })
          })
      } else {
        reject(new Error('[Sentry Raven]: initialization failed - config:sentryRavenLink is empty'))
      }
    } catch (error) {
      reject(error)
    }
  })
}
